import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { isExternalUrl, stripDomainAndProtocalFromUrl } from "../../utilities/urlHelper";

/**
 * This button handles check the url is internal, and replace it with relative path using <Link>
 * @param {*} buttonProps
 * @returns
 */
const Button = (buttonProps) => {
  const { className, href, text, type, target, children = null, title = null, wrapper = true } = buttonProps;

  //   const [isExternal, setIsExternal] = useState(isExternalUrl(href));
  const isExternal = isExternalUrl(href) ?? true;
  const [sanitisedHref, setSanitisedHref] = useState(href);

  useEffect(() => {
    if (!isExternal) {
      const cleanUrl = stripDomainAndProtocalFromUrl(href);
      setSanitisedHref(cleanUrl.startsWith("/") ? cleanUrl : "/" + cleanUrl);
    }
  }, [href, isExternal]);

  const content = (() =>
    isExternal ? (
      <a href={sanitisedHref} className={className ?? type} title={title} target={target ?? "_blank"} rel="noopener noreferrer">
        {text}
        {children}
      </a>
    ) : (
      <Link to={sanitisedHref} className={className ?? type} title={title ?? text}>
        {text}
        {children}
      </Link>
    ))();

  return wrapper ? <div className="button--container">{content}</div> : <>{content}</>;
};

export default Button;
